import { CALIBRATION_TYPES } from '@models/calibrations/calibration';
import { CalibrationStatus } from '@models/record-status';

export interface INotificationQuery {
  ProductId: number;
  CalibrationType: string;
}

export interface INotification {
  NotificationSID: number;
  Title: string;
  Description: string;
  CalibrationType: string;
  ProductId: number;
  RecordStatus: string;
  CalibrationRecordStatus: CalibrationStatus;
  DateTimeCreated: Date;
  ProductName?: string;
  ProductMnemonic?: string;
  // DateTimeModified: Date;
}

export enum NotificationCalibrationTypes {
  BETA = 'Beta',
  DECAY = 'Decay',
  STABLE_BALANCE = 'Stable Balance',
  PRODUCT_DETAIL = 'Product Detail',
  RECALCULATION = 'Recalculation'
}
